import { Injectable } from '@angular/core';

import { API_ENDPOINT, ApiApplication } from '@careconne/core/configs';

import { ApiService } from '../common';

@Injectable({
  providedIn: 'root',
})
export class RecordListService {
  constructor(private readonly http: ApiService) {}

  getRecordList(fileName: string) {
    return this.http.get(API_ENDPOINT.recordList.base + API_ENDPOINT.recordList.getDataRecord, [fileName]);
  }

  getStfcd(param: any) {
    return this.http.get(ApiApplication.USER_ROLE.CONTROLLER + ApiApplication.USER_ROLE.GET_STF_CD, [
      param.userId,
      param.roleId,
      param.careconneSchemaId,
    ]);
  }

  getDaiInfoById(id: number) {
    return this.http.get(ApiApplication.DAI.CONTROLLER + ApiApplication.DAI.GET_DAI_INFO_BY_ID, [id]);
  }

  getFile(id: number) {
    return this.http.post(ApiApplication.CARECONNE_INFO.CONTROLLER + ApiApplication.CARECONNE_INFO.GET_FILE, {
      fileId: id,
    });
  }

  getSourceApi(filePath: string) {
    return this.http.get(API_ENDPOINT.recordList.base + API_ENDPOINT.recordList.getFileSourceApi, [filePath]);
  }
}
